// getting the company ID for which the logged in mentor's has access to
export const MENTOR_DATA_FETCHED = "MENTOR_DATA_FETCHED";

export const getMentorData = (data) => ({
  type: MENTOR_DATA_FETCHED,
  payload: data,
});
